"use client"
import { useEffect } from "react"
import { isBrowser, setFavicon } from "../../utils/utils"

const Favicon = ({ metaData }) => {
  const { general } = metaData
  console.log('general', general)
  useEffect(() => {
    // isBrowser() && setFavicon(general.faviconimage || "icons/brightr.png")
    isBrowser() && setFavicon( "icons/brightr.png")
  }, [general])
  return
}

export default Favicon
